export enum EHoverpadKind {
  None = 255,
  Blade = 0,
  Stronk = 1,
}
